import { ShieldCheck, ShoppingCart } from "lucide-react";

const OPTIONS = [
  { id: "admin", label: "Admin", icon: ShieldCheck, desc: "Semua menu kecuali Kelola User", tone: "border-sky-500 bg-sky-50 text-sky-800" },
  { id: "kasir", label: "Kasir", icon: ShoppingCart, desc: "Hanya Kasir, Riwayat & Menu Pelanggan", tone: "border-amber-500 bg-amber-50 text-amber-900" },
];

export const RolePicker = ({ value, onChange }) => (
  <div className="space-y-1.5" data-testid="user-form-role-picker">
    <p className="text-sm font-medium">Role</p>
    <div className="grid grid-cols-2 gap-2">
      {OPTIONS.map(({ id, label, icon: Icon, desc, tone }) => (
        <button
          key={id}
          type="button"
          onClick={() => onChange(id)}
          data-testid={`user-form-role-${id}`}
          aria-pressed={value === id}
          className={`rounded-xl border-2 p-3 text-left transition-colors ${value === id ? tone : "border-slate-200 text-slate-600 hover:border-slate-300"}`}
        >
          <Icon className="h-5 w-5" />
          <p className="mt-1.5 text-sm font-bold">{label}</p>
          <p className="text-xs opacity-80">{desc}</p>
        </button>
      ))}
    </div>
  </div>
);
